module.exports = __webpack_public_path__ + "img/a_sulfitos.36df52ec.svg";